import axios from 'axios';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import $ from 'jquery';
import * as Yup from 'yup';
import * as APIS from '../../Config/Apis';
import { getToken } from '../../Utils/Common';
import { useComponentDidMount, withRouter } from '../../Utils/Component';
import AlertError from '../Layouts/AlertError';
import { useNavigate } from 'react-router-dom';
import { red, volcano, orange, gold, yellow, lime, green, cyan, blue, geekblue, purple, magenta, grey } from '@ant-design/colors';
import { Layout, Breadcrumb, PageHeader, Collapse, Row, Col, Button, Select, Table, Input, Space, Tag, Descriptions, Typography } from "antd";
const { Content, Footer } = Layout;
const { Panel } = Collapse;
const { Option } = Select;
const { Title } = Typography;

function SchedulesDetails() {
    const token = getToken();
    const navigate = useNavigate();
    const { id } = useParams();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [query, setQuery] = useState(null);

    const [tableError, setTableError] = useState(null);
    const [schedule, setSchedule] = useState(null);

    useComponentDidMount(() => {
        console.log(id);
        getDetails(id)
    });

    const getDetails = (id) => {
        setLoading(true);
        setTableError(null);
        const config = {
            "url": APIS.FULL_SCHEDULES_DETAILS + "?id=" + id,
            "method": "GET",
            "timeout": 0,
            "headers": Object.assign(APIS.HEADERS, { 'Authorization': 'Bearer ' + token }),
        };
        axios(config)
            .then(function (response) {
                console.log(JSON.stringify(response.data));
                setLoading(false);
                setSchedule(response.data.data);
                getTicketsTableData(id);
                getSubSchedulesTableData(id);
                getSystemDestinationsTableData(id);
                // getScheduleDestinationsTableData(id);
            })
            .catch(function (error) {
                console.log(error);
                console.log(error.response);
                setLoading(false);
                if (error.response && error.response.status) setTableError(error.response.data.message);
                else setTableError("Something went wrong. Please try again.");
            });
    };

    const goToTable = () => {
        navigate('/full-schedules');
    }

    // sub schedules
    const [subSchedulesLoading, setSubSchedulesLoading] = useState(false);
    const [subSchedulesTableData, setSubSchedulesTableData] = useState(false);
    const subSchedulesTableColumns = [
        "sub_schedule_id", // 0
        "start_bus_stop_name", // 1
        "end_bus_stop_name", // 2
        "destination_name", // 3
        "start_time", // 4
        "end_time", // 5
        "no_of_seats_available", // 6
        "no_of_seats_reserved", // 7
        "no_of_seats_booked", // 8
        "no_of_seats_remaining", // 9
        "sub_schedule_status_label", // 10
    ]
    const subSchedulesTableColumnsHead = [
        { dataIndex: subSchedulesTableColumns[0],  title: "Id" },
        { dataIndex: subSchedulesTableColumns[1],  title: "From" },
        { dataIndex: subSchedulesTableColumns[2],  title: "To" },
        { dataIndex: subSchedulesTableColumns[3],  title: "Destintation" },
        { dataIndex: subSchedulesTableColumns[4],  title: "Start Time" },
        { dataIndex: subSchedulesTableColumns[5],  title: "End Time" },
        { dataIndex: subSchedulesTableColumns[6],  title: "Seats Total" },
        { dataIndex: subSchedulesTableColumns[7],  title: "Seats Reserved" },
        { dataIndex: subSchedulesTableColumns[8],  title: "Seats Booked" },
        { dataIndex: subSchedulesTableColumns[9],  title: "Seats Remaining" },
        {
            dataIndex: subSchedulesTableColumns[10], title: "Status",
            render: value => {
                let color = grey.primary;
                if (value === 'Pending') {
                    color = red.primary;
                }
                if (value === 'Upcoming') {
                    color = purple.primary;
                }
                if (value === 'Live') {
                    color = blue.primary;
                }
                if (value === 'Completed') {
                    color = green.primary;
                }
                return (
                    <Tag color={color} key={value}>
                        {value}
                    </Tag>
                );
            }
        },
    ];
    const getSubSchedulesTableData = (id) => {
        setSubSchedulesLoading(true);
        const config = {
            "url": APIS.FULL_SCHEDULES_SUB_SCHEDULES + "?id="+id,
            "method": "GET",
            "timeout": 0,
            "headers": Object.assign(APIS.HEADERS, { 'Authorization': 'Bearer ' + token }),
        };
        axios(config)
            .then(function (response) {
                console.log(JSON.stringify(response.data));
                console.log(JSON.stringify(response.data.data.recordsTotal));
                console.log(JSON.stringify(response.data.data.recordsFiltered));
                setSubSchedulesLoading(false);
                setSubSchedulesTableData(response.data.data.data);
            })
            .catch(function (error) {
                console.log(error);
                console.log(error.response);
                setLoading(false);
                if (error.response && error.response.status) setTableError(error.response.data.message);
                else setTableError("Something went wrong. Please try again.");
            });
    };

    // system destinations
    const [systemDestinationsLoading, setSystemDestinationsLoading] = useState(false);
    const [systemDestinationsTableData, setSystemDestinationsTableData] = useState(false);
    const systemDestinationsTableColumns = [
        "destination_name", // 0
        "rura_code", // 1
        "distance", // 2
        "duration", // 3
        "price", // 4
        "count", // 5
        "amount", // 6
    ]
    const systemDestinationsTableColumnsHead = [
        { dataIndex: systemDestinationsTableColumns[0],  title: "Destination" },
        { dataIndex: systemDestinationsTableColumns[1],  title: "RuraCode" },
        { dataIndex: systemDestinationsTableColumns[2],  title: "Distance" },
        { dataIndex: systemDestinationsTableColumns[3],  title: "Duration" },
        { dataIndex: systemDestinationsTableColumns[4],  title: "Price" },
        { dataIndex: systemDestinationsTableColumns[5],  title: "Count" },
        { dataIndex: systemDestinationsTableColumns[6],  title: "Amount" },
    ];
    const getSystemDestinationsTableData = (id) => {
        setSystemDestinationsLoading(true);
        const config = {
            "url": APIS.FULL_SCHEDULES_SYSTEM_DESTINATIONS + "?id="+id,
            "method": "GET",
            "timeout": 0,
            "headers": Object.assign(APIS.HEADERS, { 'Authorization': 'Bearer ' + token }),
        };
        axios(config)
            .then(function (response) {
                console.log(JSON.stringify(response.data));
                console.log(JSON.stringify(response.data.data.recordsTotal));
                console.log(JSON.stringify(response.data.data.recordsFiltered));
                setSystemDestinationsLoading(false);
                setSystemDestinationsTableData(response.data.data.data);
            })
            .catch(function (error) {
                console.log(error);
                console.log(error.response);
                setLoading(false);
                if (error.response && error.response.status) setTableError(error.response.data.message);
                else setTableError("Something went wrong. Please try again.");
            });
    };

    // // schedule destinations
    // const [scheduleDestinationsLoading, setScheduleDestinationsLoading] = useState(false);
    // const [scheduleDestinationsTableData, setScheduleDestinationsTableData] = useState(false);
    // const scheduleDestinationsTableColumns = [
    //     "schedule_destination_name", // 0
    //     "rura_code", // 1
    //     "distance", // 2
    //     "duration", // 3
    //     "price", // 4
    //     "no_of_seats_reserved", // 5
    //     "no_of_seats_extra", // 6
    //     "schedule_destination_status_label", // 7
    // ]
    // const scheduleDestinationsTableColumnsHead = [
    //     { dataIndex: scheduleDestinationsTableColumns[0],  title: "Destination" },
    //     { dataIndex: scheduleDestinationsTableColumns[1],  title: "RuraCode" },
    //     { dataIndex: scheduleDestinationsTableColumns[2],  title: "Distance" },
    //     { dataIndex: scheduleDestinationsTableColumns[3],  title: "Duration" },
    //     { dataIndex: scheduleDestinationsTableColumns[4],  title: "Price" },
    //     { dataIndex: scheduleDestinationsTableColumns[5],  title: "Seats Reserved" },
    //     { dataIndex: scheduleDestinationsTableColumns[6],  title: "Seats Extra" },
    //     {
    //         dataIndex: scheduleDestinationsTableColumns[7], title: "Status",
    //         render: value => {
    //             let color = grey.primary;
    //             if (value === 'Blocked') {
    //                 color = red.primary;
    //             }
    //             if (value === 'Active') {
    //                 color = green.primary;
    //             }
    //             return (
    //                 <Tag color={color} key={value}>
    //                     {value}
    //                 </Tag>
    //             );
    //         }
    //     },
    // ];
    // const getScheduleDestinationsTableData = (id) => {
    //     setScheduleDestinationsLoading(true);
    //     const config = {
    //         "url": APIS.FULL_SCHEDULES_SCHEDULE_DESTINATIONS + "?id="+id,
    //         "method": "GET",
    //         "timeout": 0,
    //         "headers": Object.assign(APIS.HEADERS, { 'Authorization': 'Bearer ' + token }),
    //     };
    //     axios(config)
    //         .then(function (response) {
    //             console.log(JSON.stringify(response.data));
    //             console.log(JSON.stringify(response.data.data.recordsTotal));
    //             console.log(JSON.stringify(response.data.data.recordsFiltered));
    //             setScheduleDestinationsLoading(false);
    //             setScheduleDestinationsTableData(response.data.data.data);
    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //             console.log(error.response);
    //             setLoading(false);
    //             if (error.response && error.response.status) setTableError(error.response.data.message);
    //             else setTableError("Something went wrong. Please try again.");
    //         });
    // };

     // tickets
     const [ticketsLoading, setTicketsLoading] = useState(false);
     const [ticketsTableData, setTicketsTableData] = useState(false);
     const ticketsTableColumns = [
        "ticket_id", // 0
        "schedule_id", // 1
        "travel_time", // 2
        "price", // 3
        "bus_plate_number", // 4
        "destination_name", // 5
        "route_name", // 6
        "company_name", // 7
        "company_branch_name", // 8
        "agent_name", // 9
        "pos_serial_number", // 10
        "customer_name", // 11
        "customer_phone_number", // 12
        "pickup_point", // 13
        "seat_no", // 14
        "printed", // 15
        "channel", // 16
        "payment_type", // 17
        "payment_provider", // 18
        "transaction_id", // 19
        "momo_transaction_id", // 20
        "momo_transaction_status", // 21
        "card_number", // 22
        "card_transaction_id", // 23
        "card_transaction_status", // 24
        "card_company_name", // 25
        "card_old_balance", // 26
        "card_new_balance", // 27
        "promotion_code", // 28
        "promotion_count", // 29
        "customer_phone_number", // 30
        "requested_at", // 31
        "reserved_at", // 32
        "unreserved_at", // 33
        "confirmed_at", // 34
        "validated_at", // 35
        "validated_bus", // 36
        "validated_by_name", // 37
        "cancelled_at", // 38
        "cancelled_by_name", // 39
        "transferred_at", // 40
        "transferred_from", // 41
        "transferred_to", // 42
        "transferred_by_name", // 43
        "ticket_status", // 44
     ]
     const ticketsTableColumnsHead = [
         { dataIndex: ticketsTableColumns[0],  title: "Ticket Id" },
         { dataIndex: ticketsTableColumns[1],  title: "Trip Id" },
         { dataIndex: ticketsTableColumns[2],  title: "Travel Time" },
         { dataIndex: ticketsTableColumns[3],  title: "Price" },
         { dataIndex: ticketsTableColumns[4],  title: "Trip Bus" },
         { dataIndex: ticketsTableColumns[5],  title: "Destination" },
         { dataIndex: ticketsTableColumns[6],  title: "Route" },
         { dataIndex: ticketsTableColumns[7],  title: "Company" },
         { dataIndex: ticketsTableColumns[8],  title: "Branch" },
         { dataIndex: ticketsTableColumns[9],  title: "Agent" },
         { dataIndex: ticketsTableColumns[10],  title: "Pos" },
         { dataIndex: ticketsTableColumns[11],  title: "Customer Name" },
         { dataIndex: ticketsTableColumns[12],  title: "Customer Phone" },
         { dataIndex: ticketsTableColumns[13],  title: "Pickup Point" },
         { dataIndex: ticketsTableColumns[14],  title: "Seat No." },
         { dataIndex: ticketsTableColumns[15],  title: "Printed" },
         {
            dataIndex: ticketsTableColumns[16], title: "Channel",
            render: value => {
                let color = blue.primary;
                if (value === 'undefined') {
                    color = blue.primary;
                }
                if (value === 'pos') {
                    color = blue.primary;
                }
                if (value === 'mobile') {
                    color = blue.primary;
                }
                if (value === 'ussd') {
                    color = blue.primary;
                }
                if (value === 'web') {
                    color = blue.primary;
                }
                if (value === 'web-agent') {
                    color = blue.primary;
                }
                if (value === 'kiosk') {
                    color = blue.primary;
                }
                return (
                    <Tag color={color} key={value}>
                        {value.toUpperCase()}
                    </Tag>
                );
            }
        },
        {
            dataIndex: ticketsTableColumns[17], title: "Payment Type",
            render: value => {
                let color = purple.primary;
                if (value === 'none') {
                    color = purple.primary;
                }
                if (value === 'cash') {
                    color = purple.primary;
                }
                if (value === 'momo') {
                    color = purple.primary;
                }
                if (value === 'card') {
                    color = purple.primary;
                }
                if (value === 'centrika') {
                    color = purple.primary;
                }
                return (
                    <Tag color={color} key={value}>
                        {value.toUpperCase()}
                    </Tag>
                );
            }
        },
        {
            dataIndex: ticketsTableColumns[18], title: "Payment Provider",
            render: value => {
                let color = cyan.primary;
                if (value === 'none') {
                    color = cyan.primary;
                }
                if (value === 'mtn') {
                    color = cyan.primary;
                }
                if (value === 'tigo') {
                    color = cyan.primary;
                }
                if (value === 'airtel') {
                    color = cyan.primary;
                }
                return (
                    <Tag color={color} key={value}>
                        {value.toUpperCase()}
                    </Tag>
                );
            }
        },
         { dataIndex: ticketsTableColumns[19],  title: "Transaction Id" },
         { dataIndex: ticketsTableColumns[20],  title: "Momo Transaction Id" },
         { dataIndex: ticketsTableColumns[21],  title: "Momo Transaction Status" },
         { dataIndex: ticketsTableColumns[22],  title: "Card Number" },
         { dataIndex: ticketsTableColumns[23],  title: "Card Transaction Id" },
         { dataIndex: ticketsTableColumns[24],  title: "Card Transaction Status" },
         { dataIndex: ticketsTableColumns[25],  title: "Card Company" },
         { dataIndex: ticketsTableColumns[26],  title: "Card Old Balance" },
         { dataIndex: ticketsTableColumns[27],  title: "Card New Balance" },
         { dataIndex: ticketsTableColumns[28],  title: "Promotion Code" },
         { dataIndex: ticketsTableColumns[29],  title: "Promotion Count" },
         { dataIndex: ticketsTableColumns[30],  title: "Promotion Customer Phone" },
         { dataIndex: ticketsTableColumns[31],  title: "Booked At" },
         { dataIndex: ticketsTableColumns[32],  title: "Reserved At" },
         { dataIndex: ticketsTableColumns[33],  title: "Unreserved At" },
         { dataIndex: ticketsTableColumns[34],  title: "Confirmed At" },
         { dataIndex: ticketsTableColumns[35],  title: "Validated At" },
         { dataIndex: ticketsTableColumns[36],  title: "Validated Bus" },
         { dataIndex: ticketsTableColumns[37],  title: "Validated By" },
         { dataIndex: ticketsTableColumns[38],  title: "Cancelled At" },
         { dataIndex: ticketsTableColumns[39],  title: "Cancelled By" },
         { dataIndex: ticketsTableColumns[40],  title: "Transferred At" },
         { dataIndex: ticketsTableColumns[41],  title: "Transferred From" },
         { dataIndex: ticketsTableColumns[42],  title: "Transferred To" },
         { dataIndex: ticketsTableColumns[43],  title: "Transferred By" },
         {
            dataIndex: ticketsTableColumns[44], title: "Status",
            render: value => {
                let color = grey.primary;
                if (value === 'pending') {
                    color = red.primary;
                }
                if (value === 'requested') {
                    color = blue.primary;
                }
                if (value === 'confirmed') {
                    color = green.primary;
                }
                if (value === 'cancelled') {
                    color = grey.primary;
                }
                if (value === 'validated') {
                    color = lime.primary;
                }
                if (value === 'reserved') {
                    color = orange.primary;
                }
                if (value === 'transferred') {
                    color = purple.primary;
                }
                return (
                    <Tag color={color} key={value}>
                        {value.toUpperCase()}
                    </Tag>
                );
            }
        },
     ];
     const getTicketsTableData = (id) => {
         setTicketsLoading(true);
         const config = {
             "url": APIS.FULL_SCHEDULES_TICKETS + "?id="+id,
             "method": "GET",
             "timeout": 0,
             "headers": Object.assign(APIS.HEADERS, { 'Authorization': 'Bearer ' + token }),
         };
         axios(config)
             .then(function (response) {
                 console.log(JSON.stringify(response.data));
                 console.log(JSON.stringify(response.data.data.recordsTotal));
                 console.log(JSON.stringify(response.data.data.recordsFiltered));
                 setTicketsLoading(false);
                 setTicketsTableData(response.data.data.data);
             })
             .catch(function (error) {
                 console.log(error);
                 console.log(error.response);
                 setLoading(false);
                 if (error.response && error.response.status) setTableError(error.response.data.message);
                 else setTableError("Something went wrong. Please try again.");
             });
     };

    // const goToDetailsTickets = (id) => {
    //     navigate('/full-tickets/'+id);
    // }

    const syncSeatsButton = () => (
        <Button type="primary" loading={loading} onClick={syncSeats.bind(this)}>Sync Seats</Button>
    );
    const syncSeats = () => {
        if(schedule && schedule.schedule_id)
        setLoading(true);
        setTableError(null);
        const config = {
            "url": APIS.FULL_SCHEDULES_SYNC_SEATS + "?id=" + schedule.schedule_id,
            "method": "GET",
            "timeout": 0,
            "headers": Object.assign(APIS.HEADERS, { 'Authorization': 'Bearer ' + token }),
        };
        axios(config)
            .then(function (response) {
                console.log(JSON.stringify(response.data));
                setLoading(false);
                setSchedule(response.data.data);
                getTicketsTableData(id);
                getSubSchedulesTableData(id);
            })
            .catch(function (error) {
                console.log(error);
                console.log(error.response);
                setLoading(false);
                if (error.response && error.response.status) setTableError(error.response.data.message);
                else setTableError("Something went wrong. Please try again.");
            });
    };

    return (
        <Layout>
            <Content className="site-layout" style={{ padding: "0 15px" }}>
                <Breadcrumb style={{ margin: "5px 0" }}>
                    <Breadcrumb.Item><a>Home</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={goToTable.bind(this)}>Schedules</a></Breadcrumb.Item>
                    <Breadcrumb.Item>{id}</Breadcrumb.Item>
                    <Breadcrumb.Item>Details</Breadcrumb.Item>
                </Breadcrumb>
                <div className="site-layout-background" style={{ padding: 0, minHeight: 380 }}>
                    <PageHeader className="site-page-header" title="Schedule Details" extra={syncSeatsButton()}/>
                    <div style={{ padding: 10 }}>
                        <>
                            {tableError && <div style={{ marginBottom: "10px" }}><AlertError title="Error" message={tableError} /></div>}
                        </>
                        <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 8]} style={{ marginBottom: "10px" }}>
                            <Col className="gutter-row" xs={24} md={24} xl={8}>
                                <Descriptions bordered column={1} size="small">
                                    <Descriptions.Item label="Trip ID">{schedule ? schedule.schedule_id : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Bus">{schedule ? schedule.bus_plate_number : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Bus Route">{schedule ? schedule.route_name : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Company">{schedule ? schedule.company_name : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Start Time">{schedule ? schedule.start_time : ''}</Descriptions.Item>
                                    <Descriptions.Item label="End Time">{schedule ? schedule.end_time : ''}</Descriptions.Item>
                                </Descriptions>
                            </Col>
                            <Col className="gutter-row" xs={24} md={24} xl={8}>
                                <Descriptions bordered column={1} size="small">
                                    <Descriptions.Item label="Status">{schedule ? schedule.schedule_status_label : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Created At">{schedule ? schedule.created_at : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Created By">{schedule ? schedule.created_by_name : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Updated At">{schedule ? schedule.updated_at : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Updated By">{schedule ? schedule.updated_by_name : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Auto Schedule">{schedule ? schedule.auto_schedule_id : ''}</Descriptions.Item>
                                </Descriptions>
                            </Col>
                            <Col className="gutter-row" xs={24} md={24} xl={8}>
                                <Descriptions bordered column={1} size="small">
                                    <Descriptions.Item label="Seats Available">{schedule ? schedule.no_of_seats_available : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Seats Reserved">{schedule ? schedule.no_of_seats_reserved : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Seats Booked">{schedule ? schedule.no_of_tickets_confirmed : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Seats Confirmed">{schedule ? schedule.no_of_tickets_confirmed : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Seats Validated">{schedule ? schedule.no_of_tickets_validated : ''}</Descriptions.Item>
                                    <Descriptions.Item label="Total Amount">{schedule ? schedule.total_amount : ''}</Descriptions.Item>
                                </Descriptions>
                            </Col>
                        </Row>
                        <Descriptions bordered size="small" layout="vertical" style={{ marginBottom: "10px" }}>
                            <Descriptions.Item label="Description/Comments" span={3}>
                                {schedule ? schedule.schedule_details : ''}
                            </Descriptions.Item>
                        </Descriptions>
                        <Title level={5} style={{ marginTop: "10px" }}>Sub Schedules</Title>
                        <Table
                                rowKey={subSchedulesTableColumns[0]}
                                columns={subSchedulesTableColumnsHead}
                                dataSource={subSchedulesTableData || []}
                                loading={subSchedulesLoading}
                                title={null}
                                footer={null}
                                bordered={true}
                                size={'small'}
                                scroll={{ x: true }}
                                pagination={false} 
                            />
                        <Title level={5} style={{ marginTop: "10px" }}>System Destinations</Title>
                        <Table
                                rowKey={systemDestinationsTableColumns[0]}
                                columns={systemDestinationsTableColumnsHead}
                                dataSource={systemDestinationsTableData || []}
                                loading={systemDestinationsLoading}
                                title={null}
                                footer={null}
                                bordered={true}
                                size={'small'}
                                scroll={{ x: true }}
                                pagination={false} 
                            />
                        {/* <Title level={5} style={{ marginTop: "10px" }}>Schedule Destinations</Title>
                        <Table
                                rowKey={scheduleDestinationsTableColumns[0]}
                                columns={scheduleDestinationsTableColumnsHead}
                                dataSource={scheduleDestinationsTableData || []}
                                loading={scheduleDestinationsLoading}
                                title={null}
                                footer={null}
                                bordered={true}
                                size={'small'}
                                scroll={{ x: true }}
                                pagination={false} 
                            /> */}
                        <Title level={5} style={{ marginTop: "10px" }}>Tickets</Title>
                        <Table
                                rowKey={ticketsTableColumns[0]}
                                columns={ticketsTableColumnsHead}
                                dataSource={ticketsTableData || []}
                                loading={ticketsLoading}
                                title={null}
                                footer={null}
                                bordered={true}
                                size={'small'}
                                scroll={{ x: true }}
                                pagination={false} 
                            />
                    </div>
                </div>
            </Content>
            <Footer style={{ textAlign: "center" }}>
                Copyright © 2022 AC GROUP | Tap&Go Ticketing v7.0.0
            </Footer>
        </Layout>
    )
}

export default withRouter(SchedulesDetails);